import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaGoogle, FaEnvelope, FaLock, FaUser, FaSpinner } from 'react-icons/fa';
import OtpModal from '../../components/OtpModal';

const Auth = () => {
  const location = useLocation();
  const isSignUp = location.pathname === '/signup';
  
  const [formData, setFormData] = useState({});
  const [status, setStatus] = useState('idle'); // idle, processing, success, error
  const [message, setMessage] = useState('');
  const [showOtpModal, setShowOtpModal] = useState(false);
  
  const title = isSignUp ? 'Create Your Account' : 'Welcome Back!';
  const submitButtonText = isSignUp ? 'Sign Up' : 'Log In';

  // --- CRITICAL FIX: Set live Render Host here ---
  const API_HOST = 'https://quick-wheels-2.onrender.com';
  
  const API_ENDPOINT = isSignUp 
    ? `${API_HOST}/api/local/signup` 
    : `${API_HOST}/api/local/login`;


  const handleGoogleLogin = () => {
    // FIX: Redirects the browser directly to the live Render backend
    window.location.href = `${API_HOST}/api/auth/google`; 
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setStatus('processing');
    
    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
        credentials: 'include',
      });

      const data = await response.json();
      
      if (response.ok) {
        setStatus('success');
        
        if (isSignUp || (data.message && data.message.includes('not verified'))) {
          setShowOtpModal(true);
        } else {
          setMessage(data.message);
          setTimeout(() => {
            window.location.href = '/';
          }, 500);
        }
      } else {
        setStatus('error');
        setMessage(data.message || 'An error occurred. Please try again.');
        
        if (data.message && data.message.includes('not verified')) {
            setShowOtpModal(true); 
        }
      }
    } catch (error) {
      setStatus('error');
      setMessage('Network error. Could not connect to the server.');
    }
  };
  
  const closeOtpModal = () => {
      setShowOtpModal(false);
      setStatus('idle');
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 pt-20 px-4">
      <div className="bg-slate-800 p-8 rounded-2xl shadow-2xl w-full max-w-md text-center transition-all duration-300 ease-in-out hover:shadow-[0_0_50px_10px_rgba(251,191,36,0.5)]">
        <h2 className="text-3xl font-bold text-amber-400 mb-8">{title}</h2>
        
        {message && status === 'error' && (
            <div className="p-3 bg-red-600 text-white rounded-lg mb-4 text-sm font-medium">{message}</div>
        )}
        
        <form onSubmit={handleFormSubmit} className="space-y-6 mb-8">
          
          {isSignUp && (
            <div className="relative">
              <FaUser className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400" />
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                onChange={handleFormChange}
                required
                className="w-full py-3 pl-12 pr-4 bg-slate-900 text-white rounded-lg border border-slate-700 focus:ring-amber-400 focus:border-amber-400"
              />
            </div>
          )}

          <div className="relative">
            <FaEnvelope className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400" />
            <input
              type="email"
              name="email"
              placeholder="Email ID"
              onChange={handleFormChange}
              required
              className="w-full py-3 pl-12 pr-4 bg-slate-900 text-white rounded-lg border border-slate-700 focus:ring-amber-400 focus:border-amber-400"
            />
          </div>

          <div className="relative">
            <FaLock className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400" />
            <input
              type="password"
              name="password"
              placeholder="Password"
              onChange={handleFormChange}
              required
              className="w-full py-3 pl-12 pr-4 bg-slate-900 text-white rounded-lg border border-slate-700 focus:ring-amber-400 focus:border-amber-400"
            />
          </div>

          <button
            type="submit"
            disabled={status === 'processing'}
            className="w-full py-3 bg-amber-400 text-slate-950 font-bold rounded-lg hover:bg-amber-500 transition duration-300 shadow-md flex items-center justify-center space-x-2"
          >
            {status === 'processing' ? (
                <>
                    <FaSpinner className="animate-spin" /> <span>Processing...</span>
                </>
            ) : (
                <span>{submitButtonText}</span>
            )}
          </button>
        </form>

        <div className="flex items-center my-6">
          <div className="flex-grow border-t border-slate-600"></div>
          <span className="flex-shrink mx-4 text-slate-400 text-sm">OR</span>
          <div className="flex-grow border-t border-slate-600"></div>
        </div>

        <button
          onClick={handleGoogleLogin}
          className="w-full py-3 bg-slate-700 text-white font-bold rounded-lg hover:bg-slate-600 transition duration-300 flex items-center justify-center space-x-3 shadow-md"
        >
          <FaGoogle />
          <span>Sign In with Google</span>
        </button>

      </div>
      
      {showOtpModal && formData.email && (
        <OtpModal 
          email={formData.email} 
          onClose={closeOtpModal} 
        />
      )}
    </div>
  );
};

export default Auth;
